@import '../../../../constants/spacing.module.less';
@import '../../../../constants/screen-width-breakpoints.module.less';

.automation-playbooks {
  display: grid;
  gap: @space-24;
  grid-template-columns: repeat(3, 1fr);
  margin: @space-24 0;
  width: 100%;

  @media @tablet {
    grid-template-columns: repeat(2, 1fr);
  }

  @media @mobile {
    grid-template-columns: 1fr;
  }
}
